import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { optionsApi } from '../../constants/options-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { specificUserParams, userParams } from '../../helpers/helperfunc';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { query } from '@angular/animations';

@Injectable({
    providedIn: 'root',
})
export class OptionsService {
    permissions_entity = permissionEntity;
    optionName: any;

    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe // dont remove this
    ) {}

    getOptionsForModule(
        pagination: PaginationType,
        sort: any = null,
        type?
    ): Observable<any> {
        let query = '?';
        if (sort && false) {
            query += `sortData=${sort}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.options);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        if(type){
            query +=`&optionType=${type}`
        }
        return this.httpClientService.get(`${optionsApi.getOptions}${query}`);
    }

    createOptions(payload: any): Observable<any> {
        return this.httpClientService.post(optionsApi.createOptions, payload);
    }
    createOptionsV2(payload: any): Observable<any> {
        return this.httpClientService.post(optionsApi.createOptionsV2, payload);
    }

    editOptions(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${optionsApi.editOptions}?Id=${id}`,
            payload
        );
    }

    editOptionsV2(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${optionsApi.editOptionsv2}?Id=${id}`,
            payload
        );
    }

    deteleOptions(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${optionsApi.deteleOptions}?Id=${id}`
        );
    }
    getOptionByIdARUSubject(id: any,params): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getOptionByIdARU}${id}${params}`);
    }
    getOptionById(id: any): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getOptionById}${id}`);
    }

    getOptionsForCourseType(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getOptionCouserType}`);
    }

    getOptionsForUniversityDocumentType(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getOptionsForUniversityDocumentType}`
        );
    }

    getOptionsForApplicationType(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getOptionsForApplicationType}`
        );
    }

    getOptionsForIntake(status?: any): Observable<any> {
       
        return this.httpClientService.get(`${optionsApi.getOptionsForIntake}${
                status ? '&status=' + status : ''
            }`);
    }

    getOptionsForMarksheetType(refId?:string): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getOptionsForMarksheetType}${refId?'refeerenceId='+refId:''}`
        );
    }

    getOptionsForMarksheetSection(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getOptionsForMarksheetSection}`
        );
    }

    getOptionsForPreviousAcadmicCourse(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getOptionsForPreviousAcadmicCourse}`
        );
    }

    getOptionsForCampus(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getOptionsForCampus}`);
    }

    getInterviewStatus(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getInterviewStatus}`);
    }

    getInterviewMode(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getInterviewMode}`);
    }

    getEducationLevel(country?): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getEducationLevel}${
                country ? '&country=' + country : ''
            }`
        );
    }

    getDegreeWithFilters(country: any, educationLevel: any): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getDegree}&country=${country}&refeerenceId=${educationLevel}`
        );
    }

    getDegreeWithFiltersBoard(degreeTypeId: any): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getDegree}&refeerenceId=${degreeTypeId}`
        );
    }

    getDegree(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getDegree}`
        );
    }

    getDegreeWithFiltersV2(country: any, educationLevel: any): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getDegree}&country=${country}&refeerenceId=${educationLevel}`
        );
    }
    
    getgallwayIntrestType(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.gallwayIntrestType}`);
    }

    getOverallGrade(
        country: any,
        educationLevel: any,
        degree: string = ''
    ): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getOverallGrade}&country=${country}&refeerenceId=${educationLevel}&degree=${degree}`
        );
    }

    getUniversityRequirement(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getUniversityRequirement}`
        );
    }

    getEnglishType(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getEnglishType}`);
    }

    getInterviewFormTemplate(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getInterviewFormTemplate}`
        );
    }

    getGapYear(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getGapYear}`);
    }

    getBacklogs(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getBacklogs}`);
    }

    getBloodGroup(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getBloodGroup}`);
    }
    getBankOptions(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getBankOptions}`);
    }

    getVisaPermits(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getVisaPermits}`);
    }
    getLocation(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getLocation}`);
    }

    getHighestQualification(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getHighestQualification}`
        );
    }
    getMonths(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getMonths}`);
    }
    getYears(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getYears}`);
    }
    getGceLevel(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.gceLevel}`);
    }
    getUniversityDefault(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.universityDefault}`);
    }
    getCourseCompareParameters(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.courseCompareParameters}`
        );
    }
    getPaymentPlan(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.paymentPlan}`);
    }
    getAutomationoption(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getAutomationoption}`);
    }
    getUniversityAutomationFiles(universityId: string = ''): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.automationFile}&refeerenceId=${universityId}`
        );
    }

    oneSignalSubscribe(payload: {deviceType:string, userId:string, playerId: string}): Observable<any> {
        return this.httpClientService.post(
          `${optionsApi.OneSignalSubscribe.replace(':deviceType',payload?.deviceType).replace(':userId',payload?.userId).replace(':playerId',payload?.playerId)}`,
          {}
        );
    }

    getAttributes(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getAttributes}`);
    }

    getSubjects(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getSubjects}`);
    }

    getAllowedStrings(): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getAllowedStrings}`);
    }

    getAllFormFields(universityId?): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getAllFormFields}${universityId? '?universityId='+universityId : ''}&skip=0&limit=100`);
    }

    getCampusAsPerUniversity(universityId?): Observable<any> {
        return this.httpClientService.get(`${optionsApi.getCampusesByUniversity}${universityId}`);
    }

    getUniversityFromOptions(): Observable<any> {
        return this.httpClientService.get(
            `${optionsApi.getUniFromOptions}`
        );
    }
}
